import { injectable, inject } from 'inversify';
import type { IAuthRepository } from '@/domain/repositories/IAuthRepository';
import { Disable2FACommand } from '@/application/commands/auth/Disable2FACommand';
import { TYPES } from '@/di/tokens';

@injectable()
export class Disable2FAAction {
  constructor(
    @inject(TYPES.IAuthRepository) private authRepository: IAuthRepository
  ) {}

  async execute(command: Disable2FACommand): Promise<void> {
    await this.authRepository.disable2FA(command.password);
  }
}
